const DEPARTMENT_TEAMS_TABLE_READY = "departmentTeams-table-ready"
const SEARCH_TEXT_STATE = "departmentTeams-table-search-text-state"
const ROWS_PER_PAGE_STATE = "departmentTeams-table-rows-per-page-state"
const PAGINATION_STATE = "departmentTeams-table-pagination-state"

const DEPARTMENT_TEAMS_ID_FOR_ACTION = "departmentTeams-table-brand-id-for-action"


const ADDEDIT_DEPARTMENT_TEAMS_READY = "departmentTeams-table-addedit-departmentTeams-ready"

const initialState = {
    isDepartmentTeamsTableReady: true,
    isAddEditDepartmentTeamsReady: true,
    departmentTeams: {},

    
    departmentTeamsSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case DEPARTMENT_TEAMS_TABLE_READY:
            return Object.assign({}, state, { isDepartmentTeamsTableReady: action.payload })

        case ADDEDIT_DEPARTMENT_TEAMS_READY:
            return Object.assign({}, state, { isAddEditDepartmentTeamsReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case DEPARTMENT_TEAMS_ID_FOR_ACTION:
            return Object.assign({}, state, {departmentTeamsSelectedId:action.payload})

        default:
        return state
    
    }

}

export function departmentTeamsTableReady(data) {
    return {
        type: DEPARTMENT_TEAMS_TABLE_READY,
        payload: data
    }
}

export function addEditDepartmentTeamsReady(data) {
    return {
        type: ADDEDIT_DEPARTMENT_TEAMS_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function departmentTeamsIdForAction(departmentTeamsId){
    return{
        type:DEPARTMENT_TEAMS_ID_FOR_ACTION,
        payload:departmentTeamsId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Department Teams/redux/departmentTeams.js